import { Checkbox, Col, Form, Input, Row } from 'antd'
import FormSectionTitle from '../elements/FormSectionTitle'
import { get } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../modules/FormItems'
import React, { Fragment } from 'react'
import { compose } from 'recompose'
import withKeyValue from './HOC/WithKeyValue'
import CustomSelect from './Select/CustomSelect'
import withData from './Select/withData'

const { TextArea } = Input

function MaterialDetails(props) {
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields, line, type } = props

  const isEnquiry = type === 'Enquiry'
  const isRFQ = type === 'RFQ'
  const isVQuote = type === 'vendorQuote'
  const isQuote = type === 'Quote'
  const isSales = type === 'Order'
  const isOrder = type === 'Purchase'
  const isService = type === 'Service'
  const isFreight = type === 'Freight'

  return (
    <Fragment>
      {/*// CLIENT MATERIAL DETAILS*/}
      {!isVQuote && !isOrder && (
        <Fragment>
          <FormSectionTitle padding={2} title={'CLIENT MATERIAL DETAILS'} />
          <Row style={{ backgroundColor: '#e6f7ff' }}>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'Stock No.'}>
                {getFieldDecorator('materials.no', {
                  initialValue: get(line, 'materials.no'),
                })(<Input placeholder={'Client Stock No.'} style={{ width: '80%' }} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'Client Ref.'}>
                {getFieldDecorator('materials.clientRef', {
                  initialValue: get(line, 'materials.clientRef'),
                })(<Input placeholder={'Client Ref:'} style={{ width: '80%' }} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'DWG No.'}>
                {getFieldDecorator('materials.dwgNo', {
                  initialValue: get(line, 'materials.dwgNo'),
                })(<Input placeholder={'Client DWG No.'} style={{ width: '80%' }} />)}
              </Form.Item>
            </Col>
          </Row>
        </Fragment>
      )}

      {(isQuote || isSales || isOrder) && (
        <Fragment>
          <FormSectionTitle padding={2} title={'VENDOR MATERIAL DETAILS'} />
          <Row style={{ backgroundColor: '#f6ffe0' }}>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'SKU No.'}>
                {getFieldDecorator('vendorNo', {
                  initialValue: get(line, 'vendorNo'),
                })(<Input placeholder={'Vendor SKU No.'} style={{ width: '80%' }} />)}
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item {...fullWidthFormItemLayout} label="Warranty">
                {getFieldDecorator('vendorWarranty', {
                  initialValue: get(line, 'vendorWarranty'),
                })(<TextArea placeholder={'Vendor Warranty'} />)}
              </Form.Item>
            </Col>
          </Row>
        </Fragment>
      )}

      {/*OEM MATERIAL DETAILS*/}
      {(isEnquiry || isRFQ || isVQuote || isQuote || isSales || isOrder) && (
        <Fragment>
          <FormSectionTitle padding={2} title={'OEM MATERIAL DETAILS'} />
          <Row style={{ backgroundColor: '#fff2e6' }}>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'Part No.'}>
                {getFieldDecorator('materials.oem.no', {
                  initialValue: get(line, 'materials.oem.no'),
                })(<Input placeholder={'Part No.'} style={{ width: '80%' }} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'Brand / Model'}>
                {getFieldDecorator('materials.oem.name', {
                  initialValue: get(line, 'materials.oem.name'),
                })(<Input placeholder={'Name'} style={{ width: '80%' }} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label={'DWG No.'}>
                {getFieldDecorator('materials.oem.dwgNo', {
                  initialValue: get(line, 'materials.oem.dwgNo'),
                })(<Input placeholder={'DWG No.'} style={{ width: '80%' }} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ backgroundColor: '#fff2e6' }}>
            <Col span={12}>
              <Form.Item
                {...defaultFormItemLayout}
                style={{ fontWeight: 'bold' }}
                label="Replacement Part">
                {getFieldDecorator('materials.oem.isReplacement', {
                  initialValue: get(line, 'materials.oem.isReplacement'),
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </Form.Item>
            </Col>
          </Row>
          {getFieldValue('materials.oem.isReplacement') === true && (
            <Row style={{ backgroundColor: '#fff2e6' }}>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="Reason">
                  {getFieldDecorator('materials.oem.reason', {
                    initialValue: get(line, 'materials.oem.reason'),
                    rules: rules.input,
                  })(<ReasonSelect />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="New OEM Part No">
                  {getFieldDecorator('materials.oem.revisedPartNo', {
                    initialValue: get(line, 'materials.oem.revisedPartNo'),
                    rules: rules.input,
                  })(<Input placeholder={'New OEM No'} />)}
                </Form.Item>
              </Col>
            </Row>
          )}
        </Fragment>
      )}
    </Fragment>
  )
}

export default MaterialDetails

const ReasonSelect = compose(
  withData({ data: ['Deprecated', 'Unavailable'] }),
  withKeyValue(),
)(CustomSelect)
